import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const SetConversationAsResolved = async (domain: string, sessionId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `widget/${sessionId}/resolve`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}